module.exports = __webpack_public_path__ + "img/isPro1_2.b2458e90.png";